import get from 'lodash/get';
import isNil from 'lodash/isNil';
import { adsParameters as defaultAdsParameters } from './adsParameters';
import adsSettings from './adsSettings';
import { State, getState } from './applicationState';
import parseUtils from './parseUtils';
const ONE_HOUR_IN_MILLISECONDS = 3600000;
const makeAddIfExists = () => (targeting, key, value) => {
    if (targeting &&
        key &&
        !isNil(value) &&
        (typeof value !== 'string' || value)) {
        targeting[key] = value;
    }
};
function toTargetingBool(value) {
    return parseUtils.parseBool(value) ? 'true' : 'false';
}
function determineNewUser() {
    const isFirstVisit = getState(State.isFirstVisit);
    const firstVisitTime = getState(State.firstVisitTime);
    const firstVisitTimePlusOneHour = firstVisitTime + ONE_HOUR_IN_MILLISECONDS;
    return Boolean(isFirstVisit && firstVisitTimePlusOneHour > Date.now());
}
function getEnv() {
    const envsMap = {
        local: 'dev',
        development: 'dev',
        stage: 'stage',
        pr: 'dev',
        qa: 'dev',
        experimental: 'dev',
        itg: 'stage',
        production: 'prod',
    };
    return envsMap[getState(State.env)] || 'prod';
}
const targetBuilder = {
    build(keyReplacerMap) {
        const adsParameters = keyReplacerMap ?? defaultAdsParameters;
        const targeting = {};
        const addIfExists = makeAddIfExists();
        const guideItemDetail = adsSettings.getGuideItemDetails();
        addIfExists(targeting, adsParameters.stationId, guideItemDetail.stationId);
        addIfExists(targeting, adsParameters.programId, guideItemDetail.programId);
        addIfExists(targeting, adsParameters.topicId, guideItemDetail.topicId);
        addIfExists(targeting, adsParameters.uploadId, guideItemDetail.audioClipId);
        addIfExists(targeting, adsParameters.language, getState(State.language));
        addIfExists(targeting, adsParameters.countryRegionId, getState(State.countryRegionId));
        addIfExists(targeting, adsParameters.stationLanguage, getState(State.stationLanguage));
        addIfExists(targeting, adsParameters.isNewUser, toTargetingBool(determineNewUser()));
        addIfExists(targeting, adsParameters.isFamily, toTargetingBool(adsSettings.isFamilyContent()));
        addIfExists(targeting, adsParameters.isMature, toTargetingBool(adsSettings.isMatureContent()));
        addIfExists(targeting, adsParameters.isEvent, toTargetingBool(adsSettings.isEvent()));
        addIfExists(targeting, adsParameters.isOnDemand, toTargetingBool(adsSettings.isOnDemand()));
        addIfExists(targeting, adsParameters.class, adsSettings.getClass());
        addIfExists(targeting, adsParameters.genreId, adsSettings.getGenreId());
        addIfExists(targeting, adsParameters.bandId, adsSettings.getBandId());
        addIfExists(targeting, adsParameters.categoryId, getState(State.categoryId));
        addIfExists(targeting, adsParameters.screen, getState(State.currentScreen));
        const lotameAudiences = getState(State.lotameAudiences, []);
        addIfExists(targeting, adsParameters.lotameSegments, lotameAudiences);
        const listingId = guideItemDetail.topicId ||
            guideItemDetail.programId ||
            guideItemDetail.stationId;
        if (listingId) {
            addIfExists(targeting, adsParameters.listingId, listingId);
        }
        if (getState(State.canShowPersonalizedAds)) {
            addIfExists(targeting, adsParameters.targetingIdl, get(getState(State.config), 'targetingIdl'));
        }
        const videoAdPlayed = getState(State.videoAdPlayed);
        addIfExists(targeting, adsParameters.videoAdPlayed, toTargetingBool(videoAdPlayed));
        const options = getState(State.options);
        if (options) {
            addIfExists(targeting, adsParameters.persona, options['ads.persona']);
            addIfExists(targeting, adsParameters.abTest, options['abtest.ids']);
            const unlockEnabled = toTargetingBool(options['unlockedContent.enabled']);
            addIfExists(targeting, adsParameters.unlockEnabled, unlockEnabled);
        }
        const unlockDetails = getState(State.unlockDetails);
        if (unlockDetails) {
            addIfExists(targeting, adsParameters.campaignId, unlockDetails.CampaignId);
            addIfExists(targeting, adsParameters.nflUnlocks, unlockDetails.NflUnlocks);
        }
        addIfExists(targeting, adsParameters.isUnlocked, toTargetingBool(adsSettings.isUnlocked()));
        addIfExists(targeting, adsParameters.isLoggedIn, toTargetingBool(getState(State.isRegisteredUser)));
        const ccpaData = getState(State.ccpaData, {});
        addIfExists(targeting, adsParameters.usPrivacy, ccpaData.usPrivacyString);
        addIfExists(targeting, adsParameters.partnerId, getState(State.partnerId));
        addIfExists(targeting, adsParameters.premium, toTargetingBool(adsSettings.isPremium()));
        addIfExists(targeting, adsParameters.env, getEnv());
        addIfExists(targeting, adsParameters.adsPartnerAlias, get(getState(State.config), 'targeting.ads_partner_alias'));
        addIfExists(targeting, adsParameters.affiliateIds, get(getState(State.nowPlaying), 'classification.affiliateIds'));
        return targeting;
    },
};
export default targetBuilder;
